import React, { useEffect } from "react";
import logo from "../assets/images/logo.png";

const Header = () => {
  useEffect(() => {
    // --- Script de Wistia ---
    const script1 = document.createElement("script");
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;

    const script2 = document.createElement("script");
    script2.src = "https://fast.wistia.com/embed/71ycs7kray.js";
    script2.async = true;
    script2.type = "module";

    document.body.appendChild(script1);
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  // --- Script de Calendly ---
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // --- Scroll suave al Calendly ---
  const scrollToCalendly = () => {
    const calendlySection = document.getElementById("calendly-section");
    if (calendlySection) {
      calendlySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  // --- Año dinámico ---
  const currentYear = new Date().getFullYear();

  return (
    <>
      <header className="bg-gray-100 text-center py-14 px-4">
        {/* Texto principal */}
       <div className="mb-10 text-center">
    <h1 className="text-2xl sm:text-5xl font-extrabold text-gray-900 leading-snug sm:leading-tight tracking-tight text-center">
        {/* Mobile */}
        <span className="block sm:hidden">
            Te ayudamos a agendar entre 20 y 40 citas calificadas extra al mes en tu negocio <br />
            con{" "}
            <span className="text-blue-600 font-semibold">
                nuestro Sistema Inteligente de Calificación y Agendamiento 24/7
            </span>
        </span>

        {/* Desktop */}
        <span className="hidden sm:block">
            Te ayudamos a agendar entre 20 y 40 citas calificadas extra <br />
            al mes en tu negocio <br />
            con nuestro {" "}
            <span className="text-blue-600 font-semibold">
                Sistema Inteligente de Calificación y Agendamiento 24/7
            </span>
        </span>
    </h1>

    <p className="text-gray-600 text-sm sm:text-lg mt-4 sm:mt-6 font-medium italic">
        *Sin invertir un centavo extra en publicidad*
    </p>
</div>

        {/* Video de Wistia */}
        <div className="video-container mt-2 sm:mt-8 mb-4 sm:mb-8 mx-auto w-full max-w-6xl">
          <style>
            {`
              wistia-player[media-id='71ycs7kray']:not(:defined) {
                background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/71ycs7kray/swatch');
                display: block;
                filter: blur(5px);
                padding-top:56.25%;
              }
            `}
          </style>

          <wistia-player
            media-id="71ycs7kray"
            aspect="1.7777777777777777"
            class="rounded-lg shadow-lg"
          ></wistia-player>
        </div>

        {/* Botón CTA */}
        <div className="mb-14">
          <button
            onClick={scrollToCalendly}
            className="relative overflow-hidden bg-gradient-to-r from-blue-600 via-blue-500 to-blue-700 
              text-white text-base sm:text-xl font-bold py-3 sm:py-4 px-8 sm:px-12 rounded-xl 
              shadow-lg hover:shadow-2xl transition-all duration-500 ease-in-out 
              hover:scale-105 animate-pulse hover:animate-none"
          >
            <span className="relative z-10">Agendar Llamada Gratuita</span>
            <span className="absolute inset-0 bg-gradient-to-r from-blue-700 via-blue-600 to-blue-800 opacity-0 hover:opacity-100 transition-opacity duration-500"></span>
          </button>
        </div>

        {/* Texto previo al Calendly */}
        <div id="calendly-section" className="max-w-4xl mx-auto text-center px-6 mb-10">
          <p className="text-gray-800 text-xl sm:text-2xl leading-relaxed font-semibold">
            Si tienes un{" "}
            <span className="text-blue-600 font-extrabold underline underline-offset-4">
              NEGOCIO
            </span>
            , y{" "}
            sientes que estás {" "}
            <span className="text-blue-600 font-bold">
              quemando tu dinero cada semana
            </span>{" "}
            en ventas que nunca se concretan porque{" "}
            <span className="text-gray-900 font-black text-2xl sm:text-3xl">
              tus respuestas llegan tarde
            </span>
            ,{" "}
            <span className="font-semibold text-gray-700">
              no das seguimiento a tiempo
            </span>
            , o{" "}
            <span className="font-semibold text-gray-700">
              tu equipo simplemente no puede atender a todos esos prospectos.
            </span>
          </p>

          <p className="text-blue-600 font-black text-2xl sm:text-3xl mt-8 uppercase tracking-wide relative inline-block">
            <span className="relative z-10">⚡ Agenda tu llamada ahora!</span>
            <span className="absolute bottom-0 left-0 w-full h-[3px] bg-blue-500 animate-pulse"></span>
          </p>
        </div>

        {/* Calendly Embed */}
        <div className="w-full mb-8 px-2 sm:px-0">
          <div
            className="calendly-inline-widget w-full max-w-5xl mx-auto"
            data-url="https://calendly.com/michaelcarrillocommunity/consultoria-ia"
            style={{
              minWidth: "300px",
              height: "1000px",
              border: "none",
              overflow: "hidden",
            }}
          ></div>
        </div>
      </header>

      {/* Footer */}
      <footer className="bg-gray-100 py-6 px-4 border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-600 text-xs sm:text-sm">
            © Frontier {currentYear}. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Header;
